import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['consent', 'country'];

    connect() {
        this.update();
    }

    update() {
        this.countryTarget.required = this.consentTarget.checked;
    }
}
